import * as React from 'react';
import Container from 'containers/Container';
import {Helmet} from 'react-helmet';

/**
 * The not found page
 * @constructor
 */
export default function NotFound(): React.ReactElement {
  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / 404 / Страница не найдена</title>
      </Helmet>
      <Container>
        <h1>Страница не найдена</h1>
      </Container>
    </React.Fragment>
  );
}
